const React = require('react')
const LayoutOuter = require('./src/layout/templates/LayoutOuter/index.js').default

exports.wrapPageElement = ({ element, props }) => {
  // props provide same data to Layout as Page element will get
  // including location, data, etc - you don't need to pass it
  return <LayoutOuter {...props}>{element}</LayoutOuter>
}
